(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@babel/runtime/helpers/asyncToGenerator'), require('@babel/runtime/regenerator'), require('broker-factory'), require('fast-unique-numbers')) :
    typeof define === 'function' && define.amd ? define(['exports', '@babel/runtime/helpers/asyncToGenerator', '@babel/runtime/regenerator', 'broker-factory', 'fast-unique-numbers'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.mediaEncoderHostBroker = {}, global._asyncToGenerator, global._regeneratorRuntime, global.brokerFactory, global.fastUniqueNumbers));
})(this, (function (exports, _asyncToGenerator, _regeneratorRuntime, brokerFactory, fastUniqueNumbers) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
    var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);

    var encoderIds = new Set();
    var wrap = brokerFactory.createBroker({
      encode: function encode(_ref) {
        var call = _ref.call;
        return /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(encoderId, timeslice) {
            var arrayBuffers;
            return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return call('encode', {
                      encoderId: encoderId,
                      timeslice: timeslice
                    });
                  case 2:
                    arrayBuffers = _context.sent;
                    encoderIds["delete"](encoderId);
                    return _context.abrupt("return", arrayBuffers);
                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
          return function (_x, _x2) {
            return _ref2.apply(this, arguments);
          };
        }();
      },
      instantiate: function instantiate(_ref3) {
        var call = _ref3.call;
        return /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee2(mimeType, sampleRate) {
            var encoderId, port;
            return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    encoderId = fastUniqueNumbers.addUniqueNumber(encoderIds);
                    _context2.next = 3;
                    return call('instantiate', {
                      encoderId: encoderId,
                      mimeType: mimeType,
                      sampleRate: sampleRate
                    });
                  case 3:
                    port = _context2.sent;
                    return _context2.abrupt("return", {
                      encoderId: encoderId,
                      port: port
                    });
                  case 5:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));
          return function (_x3, _x4) {
            return _ref4.apply(this, arguments);
          };
        }();
      },
      register: function register(_ref5) {
        var call = _ref5.call;
        return function (port) {
          return call('register', {
            port: port
          }, [port]);
        };
      }
    });
    var load = function load(url) {
      var worker = new Worker(url);
      return wrap(worker);
    };

    exports.load = load;
    exports.wrap = wrap;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
